import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormControlServiceBase } from '../types/form-control-service.base';
import { IDateFormControlOptions } from './types/i-date-form-control-options';

@Injectable()
export class DateFormControlService implements FormControlServiceBase<'date'> {

  readonly formatSubject = new BehaviorSubject<IDateFormControlOptions['format']>('dd/MM/yyyy');
  readonly minSubject = new BehaviorSubject<Date>(null);
  constructor() { }

}
